import { useFirm } from '@/database/hooks/hooks';
import ObjectFieldsSection from './ObjectFieldsSection';

const FirmDocumentSection = () => {
  const { firm } = useFirm();

  return <ObjectFieldsSection document={firm} title='Firm Document' />;
};

export default FirmDocumentSection;
